{
  "version": 1,
  "asset_id": "f5c6dcc2-aec3-4596-b3fb-4f17dfc176c8",
  "project_id": "01579873-aba5-45c2-b48e-0fe42afbbb35",
  "url": "/__l5e/assets-v1/f5c6dcc2-aec3-4596-b3fb-4f17dfc176c8/stamp.png",
  "r2_key": "a/v1/01579873-aba5-45c2-b48e-0fe42afbbb35/f5c6dcc2-aec3-4596-b3fb-4f17dfc176c8/stamp.png",
  "original_filename": "stamp.png",
  "size": 44030,
  "content_type": "image/png",
  "created_at": "2026-06-16T18:26:10Z"
}
